<!--
 * @Description: 抽奖成功
 * @Author: yl
 * @Date: 2021-05-31 13:46:13
 * @LastEditTime: 2021-06-02 21:06:49
 * @LastEditors: yl
-->
<template>
    <van-dialog class="lotterySuccess" v-model="dialog" title="" :showConfirmButton="false" :closeOnClickOverlay="false"
        :closeOnPopstate="false">
        <div class="content bv bc">
            <van-row type="flex" align="center" justify="center">
                <van-image class="icon" :src="require('@/assets/imges/lottery/integralIcon.png')" />
            </van-row>
            <div class="text">{{'恭喜你，获得'+ Number(num) +'车主币'}}</div>
            <van-image class="closeBtn" @click="getIntegral" :src="require('@/assets/imges/lottery/getIntegral.png')" />
        </div>
    </van-dialog>
</template>

<script>
import { user } from "@/mixin/user";
export default {
    mixins: [user],
    components: {},
    name: "",
    props: {
        dialog: null,
        num: null
    },
    data() {
        return {
            start: false
        };
    },
    methods: {
        getIntegral() {
            this.closeDialog()
        },
        closeDialog() {
            // 获取用户信息
            this.refreshUser();
            this.$emit('update:dialog', false)
        }
    }
};
</script>

<style scoped lang="scss">
.lotterySuccess {
    background: transparent;

    .van-dialog__content {
        width: 100%;
        height: 100%;

        .content {
            .icon {
                width: 468px;
                height: 475px;
            }
            .text {
                margin-top: 16px;
                font-size: 35px;
                color: #ffffff;
            }
        }
    }
    ::v-deep .van-dialog__footer {
        display: none;
    }

    .closeBtn {
        width: 570px;
        height: 100px;
        margin-top: 111px;
    }
}
</style>